/// <reference path="../../global/fn.js" />

(function ($) {
  $.widget("nsp.compareTwo", {
    options: {},

    _create: function () {
      this.wrap = this.element;
      this.allTxtsInCard = $(".b-product-card", this.wrap).find(".b-product-card__txt").length / 2;
      this.timer = 0;

      this._iniForEqualHeights();

      this._setEqualHeights();

      this.iniSlick();


      $(document).on("window-resized", () => {
        clearTimeout(this.timer)
        this._setEqualHeights();
        this.iniSlick();

      });

    },

    iniSlick: function () {
      if (api.vars.windW < api.vars.scr.tablet) {
        if (!this.wrap.hasClass("slick-initialized")) {
          this.wrap.slick({
            rows: 0,
            slidesToShow: 1,
            slidesToScroll: 1,
            dots: true,
            arrows: false,
            infinite: false,
            variableWidth: true,
          });
        }
      } else {
        if (this.wrap.hasClass("slick-initialized")) {
          this.wrap.slick("unslick");
        }
      }
    },

    _iniForEqualHeights: function () {
      $(".b-product-card", this.wrap).each((indx, item) => {
        var card = $(item);
        var txt = $(".b-product-card__txt", card);
        txt.each((indx, txtItem) => {
          $(txtItem).addClass("compare-height-" + indx);
        });
      });
    },

    _setEqualHeights: function () {
      this.timer = setTimeout(() => {
        $(".b-product-card__txt", this.wrap).css("height", "auto");

        for (var i = 0; i < this.allTxtsInCard; i++) {
          api.fn.equalHeights($(".compare-height-" + i));
        }
      }, 100);

      //
    },
  });
})(jQuery);
